import { isNotDefined } from '@sgme/fp';

import { optionRepriceQuote } from '@/store/blotter/workflows/cashRepriceQuote/action.ts';
import type { StartAppListening } from '@/store/listenerMiddleware.ts';
import { optionSlice } from '@/store/option/slice.ts';
import { checkOptionThunk } from '@/store/option/thunks/checkOptionThunk.ts';

export const registerOpenBlotterListenerForOptions = (startAppListening: StartAppListening) => {
  startAppListening({
    actionCreator: optionRepriceQuote,
    effect: async (action, api) => {
      const state = api.getState();
      const { tileId, productType } = action.payload;

      const option = optionSlice.selectors.getOptionTile(state, tileId);
      if (isNotDefined(option) || productType !== 'Option') {
        return;
      }

      api.dispatch(
        checkOptionThunk({
          type: 'init',
          tileId,
          shouldApplyUserPrefs: false,
        }),
      );
    },
  });
};
